export function countDecimalPlaces(num) {
    var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) { return 0; }
    return Math.max(
        0,
        // Number of digits right of decimal point.
        (match[1] ? match[1].length : 0)
        // Adjust for scientific notation.
        - (match[2] ? +match[2] : 0));
}

export function toZar(money) {
    if(money)
        return 'R' + (countDecimalPlaces(money) == 1 ? money.toLocaleString() +  '0' : money.toLocaleString());
    else 
        return 'R0.00'
}

export function toCurrency(money, currencyPrefix) {
    if(money)
        return currencyPrefix + (countDecimalPlaces(money) == 1 ? money.toLocaleString() +  '0' : money.toLocaleString());
    else 
        return currencyPrefix + '0.00'
}

export function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

Number.prototype.toZar = function () { return toZar(this); }
Number.prototype.formatNumber = function () { return formatNumber(this); }
